/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.schools.schools'},
});

const SchoolsItem = () => (
  <RouteLinkItem
    route="midas/settings/schools/schools"
    title={messages.title}
  />
);

export default SchoolsItem;
